var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.00008H13.3334C13.3334 3.15841 11.8417 1.66675 10 1.66675C8.15837 1.66675 6.66671 3.15841 6.66671 5.00008H5.00004C4.08337 5.00008 3.33337 5.75008 3.33337 6.66675V16.6667C3.33337 17.5834 4.08337 18.3334 5.00004 18.3334H15C15.9167 18.3334 16.6667 17.5834 16.6667 16.6667V6.66675C16.6667 5.75008 15.9167 5.00008 15 5.00008ZM10 3.33341C10.9167 3.33341 11.6667 4.08341 11.6667 5.00008H8.33337C8.33337 4.08341 9.08337 3.33341 10 3.33341ZM15 16.6667H5.00004V6.66675H6.66671V8.33342C6.66671 8.79175 7.04171 9.16675 7.50004 9.16675C7.95837 9.16675 8.33337 8.79175 8.33337 8.33342V6.66675H11.6667V8.33342C11.6667 8.79175 12.0417 9.16675 12.5 9.16675C12.9584 9.16675 13.3334 8.79175 13.3334 8.33342V6.66675H15V16.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.34a26e32037b238b331339b85bbd9b2b.svg";
export { ForwardRef as ReactComponent };